import { Injectable } from '@angular/core';
import { AggregationTypes } from '@constants/pages/interactive-data-analysis/aggregation-types';
import { AggregationType } from '@models/pages/interactive-data-analysis/aggregation-type';

@Injectable({
  providedIn: 'root'
})
export class AggregationTypesService {

  public  TYPE_SECOND = new AggregationType(AggregationTypes.SECOND, 'Second', 'HH:mm:ss', '%H:%M:%S', 'true');

  public  TYPE_SECONDS10 = new AggregationType(AggregationTypes.SECONDS10, '10 Seconds', 'MM-dd HH:mm:ss', '%H:%M:%S');
  public  TYPE_SECONDS10_WITH_DEFAULT = new AggregationType(AggregationTypes.SECONDS10, '10 Seconds', 'MM-dd HH:mm:ss', '%H:%M:%S', 'true');
  public  TYPE_SECONDS10_WITH_MONTH_DEFAULT = new AggregationType(AggregationTypes.SECONDS10, '10 Seconds', 'MM-dd HH:mm:ss', '%m-%d %H:%M:%S', 'true');

  public  TYPE_MINUTE = new AggregationType(AggregationTypes.MINUTE, 'Minute', 'MM-dd HH:mm', '%H:%M');
  public  TYPE_MINUTE_WITH_MONTH = new AggregationType(AggregationTypes.MINUTE, 'Minute', 'MM-dd HH:mm', '%m-%d %H:%M');
  public  TYPE_MINUTE_WITH_MONTH_DEFAULT = new AggregationType(AggregationTypes.MINUTE, 'Minute', 'MM-dd HH:mm', '%m-%d %H:%M', 'true');

  public  TYPE_MINUTES15 = new AggregationType(AggregationTypes.MINUTES15, '15 Minutes', 'MM-dd HH:mm', '%H:%M');
  public  TYPE_MINUTES15_WITH_DEFAULT = new AggregationType(AggregationTypes.MINUTES15, '15 Minutes', 'MM-dd HH:mm', '%H:%M', 'true');
  public  TYPE_MINUTES15_WITH_MONTH = new AggregationType(AggregationTypes.MINUTES15, '15 Minutes', 'MM-dd HH:mm', '%m-%d %H:%M');
  public  TYPE_MINUTES15_WITH_MONTH_DEFAULT = new AggregationType(AggregationTypes.MINUTES15, '15 Minutes', 'MM-dd HH:mm', '%m-%d %H:%M', 'true');
  public  TYPE_MINUTES15_WITH_DAYS_DEFAULT = new AggregationType(AggregationTypes.MINUTES15, '15 Minutes', 'MM-dd HH:mm', '%d %H:%M', 'true');

  public  TYPE_HOUR = new AggregationType(AggregationTypes.HOUR, 'Hour', 'MM-dd HH:mm', '%H:00');
  public  TYPE_HOUR_WITH_MONTH = new AggregationType(AggregationTypes.HOUR, 'Hour', 'MM-dd HH:00', '%m-%d %H:00');
  public  TYPE_HOUR_WITH_DAYS = new AggregationType(AggregationTypes.HOUR, 'Hour', 'MM-dd HH:mm', '%d %H:00');
  public  TYPE_HOUR_WITH_DEFAULT = new AggregationType(AggregationTypes.HOUR, 'Hour', 'MM-dd HH:mm', '%H:00', 'true');
  public  TYPE_HOUR_WITH_MONTH_DEFAULT = new AggregationType(AggregationTypes.HOUR, 'Hour', 'MM-dd HH:mm', '%m-%d %H:%M', 'true');
  public  TYPE_HOUR_WITH_MONTH_MINUTES_ZERO_DEFAULT = new AggregationType(AggregationTypes.HOUR, 'Hour', 'MM-dd HH:00', '%m-%d %H:00', 'true');

  public  TYPE_DAY = new AggregationType(AggregationTypes.DAY, 'Day', 'MM-dd', '%d');
  public  TYPE_DAY_WITH_MONTH = new AggregationType(AggregationTypes.DAY, 'Day', 'MM-dd', '%m-%d');
  public  TYPE_DAY_WITH_MONTH_DEFAULT = new AggregationType(AggregationTypes.DAY, 'Day', 'MM-dd', '%m-%d', 'true');

  public  TYPE_MONTH = new AggregationType(AggregationTypes.MONTH, 'Month', 'MM-dd', '%m');


}
